import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "13",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  mask: "url(#mask0_1951_58790)",
  stroke: "#F59600",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M8.996 1.438C3.57 1.438 1.4 6.5 1.4 6.5s2.17 5.062 7.596 5.062S16.592 6.5 16.592 6.5s-2.17-5.062-7.596-5.062Z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M8.996 8.96c1.311 0 2.374-1.101 2.374-2.46s-1.063-2.46-2.374-2.46C7.684 4.04 6.62 5.14 6.62 6.5s1.063 2.46 2.375 2.46Z" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };